import httpClient from "Api/httpClient";

const END_POINT = "/shipment_planner";

const getShipmentPlanners = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getShipmentPlanner = (payload, shipment_id) => {
    let body = "";
    if (payload.body) body = payload.body;
    if (!shipment_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + shipment_id;
    return httpClient.get(SINGLE_END_POINT, { params: body });
};

const printShipmentPlanner = (shipment_id) => {
    if (!shipment_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?shipment_id=" + shipment_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createShipmentPlanners = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateShipmentPlanners = (payload, shipment_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + shipment_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteShipmentPlanners = (shipment_id) => {
    const DELETE_END_POINT = END_POINT + "/" + shipment_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getShipmentPlanners, getShipmentPlanner, printShipmentPlanner, createShipmentPlanners, updateShipmentPlanners, deleteShipmentPlanners };
